import { render, staticRenderFns } from "./BFormInputCurrency.vue?vue&type=template&id=a9d4d0ae&"
import script from "./BFormInputCurrency.vue?vue&type=script&lang=js&"
export * from "./BFormInputCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports